import { Container } from '@mui/material'
import { useStyles } from './styles'
import NavBar from '@/features/navbar/index'
import { useEffect, useRef } from 'react'
import { innerWidthChangeEvent } from '@/entities/navigation/events'
import { $scrollAllowed } from '@/entities/navigation/store'
import { useUnit } from 'effector-react'
import { changeNavVisibilityFx } from '@/entities/navigation/effects'
import { GlobalBuyKeysModal } from '@/features/buyKeysModal/global'

type ContainerProps = {
  children: React.ReactNode
}

export const AppContainer = ({ children }: ContainerProps) => {
  const { classes } = useStyles({})
  const scrollAllowed = useUnit($scrollAllowed)
  const mainViewRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setTimeout(() => {
      changeNavVisibilityFx(true)
    }, 50)

    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        const width = entries[0].contentRect.width
        innerWidthChangeEvent(width)
      }
    })

    if (mainViewRef.current) {
      observer.observe(mainViewRef.current)
    }

    const mainView = mainViewRef.current

    return () => {
      if (mainView) {
        observer.unobserve(mainView)
      }
    }
  }, [])

  return (
    <Container
      ref={mainViewRef}
      classes={{ root: classes.root }}
      data-scroll-allowed={scrollAllowed}
      maxWidth="md"
    >
      <>{children}</>
      <GlobalBuyKeysModal />
      <NavBar />
    </Container>
  )
}
